import { PAGINATION_ALL_ITEMS_VALUE } from '../../../constants/pagination'
import {
  deleteApi,
  getApi,
  patchApi,
  postApi,
  putApi,
} from '../../../utils/api'
import { getPaginationApiParams } from '../../../utils/pagination'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

import {
  DOC_FLOW_UPLOADING_EMPTY_REQUEST_PARAMS,
  DOC_FLOW_UPLOADING_TABLE_CONFIG_URL,
} from './DocFlowUploading.constants'
import { getUploadingFilesListApi } from './DocFlowUploading.utils'

export function uploadingPhaseDeleteFile(documentId, fileId) {
  return deleteApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${fileId}/`,
  })
}

export function updateTableConfig(data) {
  return putApi({
    data,
    endpoint: `${DOC_FLOW_UPLOADING_TABLE_CONFIG_URL}config/`,
  })
}

export function getUploadingFilesAll(
  documentId,
  data = DOC_FLOW_UPLOADING_EMPTY_REQUEST_PARAMS
) {
  return postApi({
    data: {
      ...data,
      ...getPaginationApiParams(PAGINATION_ALL_ITEMS_VALUE),
    },
    endpoint: getUploadingFilesListApi(documentId),
  })
}

export function updateUploadingItem({ data, id, itemId }) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${id}/uploading-files/${itemId}/`,
  })
}

export function getUploadingItem({ documentId, itemId }) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/`,
  })
}

export function updateDocFlowUploadingFileProcess({ data, id, itemId }) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${id}/uploading-files/${itemId}/process/`,
  })
}

export function getUploadingWidgetProcess({ documentId, itemId }) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/process/`,
  })
}

export function getSplittingValueInArea({ data, documentId, itemId }) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/pre-splitting/`,
  })
}

export function getMappingValueInArea({ data, documentId, itemId }) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/pre-mapping/`,
  })
}

export function resetUploadingFilesProcess({ documentId, itemId }) {
  return postApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/${itemId}/process/reset/`,
  })
}

export function performDocFlowUploadingMassAction(documentId, data) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/uploading-files/mass-action/`,
  })
}
